exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-container {\n  margin-top: 100px;\n}\n\n.col-sm-6 {\n  text-align: center;\n}\n\n.col-sm-6 h2 {\n  color: #666666;\n}\n\n.circle {\n  width: 170px;\n  height: 170px;\n  border-radius: 50%;\n  background: #f2f2f2;\n  display: table;\n  margin: 0 auto;\n}\n\n.circle i {\n  display: table-cell;\n  vertical-align: middle;\n  font-size: 60px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/main/main.component.css
// module id = ../../../../../src/app/components/main/main.component.css
// module chunks = main